import TourCard from "./TourCard";

import { Swiper, SwiperSlide } from "swiper/react";

import SwiperCore, { Autoplay, Navigation } from "swiper";
import { useEffect, useState } from "react";

export default function TourCarousel(props) {
  const { tours } = props;

  SwiperCore.use([Navigation, Autoplay]);
  // const [nav, setNav] = useState(false);
  // const [num, setNum] = useState(4);

  // useEffect(() => {
  //   if (window.innerWidth < 1200) {
  //     setNum(3);
  //     setNav(
  //       tours.length > 3
  //         ? {
  //             nextEl: ".swiper-button-next",
  //             prevEl: ".swiper-button-prev",
  //           }
  //         : false
  //     );
  //   } else {
  //     setNum(4);
  //     setNav(
  //       tours.length > 4
  //         ? {
  //             nextEl: ".swiper-button-next",
  //             prevEl: ".swiper-button-prev",
  //           }
  //         : false
  //     );
  //   }
  //   console.log("HERE");
  // }, []);

  return (
    <>
      <Swiper
        spaceBetween={50}
        slidesPerView={1}
        observer={true}
        observeParents={true}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        autoplay={{ delay: 5000, pauseOnMouseEnter: true }}
        breakpoints={{
          // when window width is >= 320px
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          // when window width is >= 535px
          535: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          // when window width is >= 992px
          992: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
        }}
        key={Math.random() * 50}
      >
        <div
          class={`swiper-button-prev d-none ${
            tours.length > 4 ? "d-xl-flex" : tours.length > 3 ? "d-lg-flex d-xl-none" : ""
          }`}
        ></div>
        <div
          class={`swiper-button-next d-none ${
            tours.length > 4 ? "d-xl-flex" : tours.length > 3 ? "d-lg-flex d-xl-none" : ""
          }`}
        ></div>
        {tours.map((tour) => (
          <SwiperSlide>
            <TourCard tour={tour} />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
}
